<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Motivation</h1>

                <p class="h2">Alles beginnt mit dem Fragebogen</p>
            </div>
            <div class="right-wrapper">
                <h2>Das personalisierte Programm wird anhand der Daten aus dem Einführungsfragebogen erstellt</h2>
                <p class="text">Die Nutzenden bewerten ihr Verhalten in den Bereichen Essgewohnheiten, Schlaf, körperliche Aktivität und Stressbewältigung.</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" weiterBtn :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 8
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

